import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface SurveyAnalytics {
  target: number
  sent: number
  deliveryRate: number
  openRate: number
  responseRate: number
}

interface GetSurveyAnalyticsRequest {
  id: number
}

export const getSurveyAnalyticsQueryKey = (data: GetSurveyAnalyticsRequest) => [
  'useGetSurveyAnalytics',
  data,
]

export const getSurveyAnalytics = async ({ id }: GetSurveyAnalyticsRequest) => {
  const { data } = await authAPI.get<SurveyAnalytics>(`/survey/${id}/analytics`)
  return data
}

export const useGetSurveyAnalytics = (data: GetSurveyAnalyticsRequest) => {
  return useQuery({
    enabled: !!data.id,
    queryFn: () => getSurveyAnalytics(data),
    queryKey: getSurveyAnalyticsQueryKey(data),
  })
}
